import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import CModal from '@/components/CModal.vue';
import CButton from '@/components/shared/CButton';
import CTextarea from '@/components/shared/CTextarea.vue';
import type { BoundedTextElement, TextPathCandidate } from '@/typings/customilyElements/canvasElements';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextPathImportModal',
  props: {
    value: { type: Boolean },
    textElement: null
  },
  emits: ["input", "apply"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
    (event: 'apply', pathData: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: boolean;
    textElement?: BoundedTextElement;
};

const MAX_FILE_MB = 2;





const source = ref('');
const fileError = ref('');
const selectedIndex = ref(0);
const isDraggingOver = ref(false);
const fileInput = ref<HTMLInputElement>();

const candidates = computed<TextPathCandidate[]>(() => props.textElement?.parseTextPathSource(source.value) ?? []);
const selected = computed(() => candidates.value[selectedIndex.value]);
const errorMsg = computed(() => {
    if (fileError.value) return fileError.value;
    return source.value.trim() && !candidates.value.length ? 'No usable path was found in this SVG.' : '';
});

watch(candidates, () => {
    selectedIndex.value = 0;
});

watch(
    () => props.value,
    (isOpen) => {
        if (!isOpen) return;
        source.value = '';
        fileError.value = '';
    }
);

const onSourceInput = (value: string) => {
    source.value = value;
    fileError.value = '';
};

const readFile = async (file?: File) => {
    if (!file) return;
    if (file.size > MAX_FILE_MB * 1024 * 1024) {
        fileError.value = `The file is larger than ${MAX_FILE_MB} MB.`;
        return;
    }
    source.value = await file.text();
    fileError.value = '';
};

const openFilePicker = () => fileInput.value?.click();

const onFileSelected = (event: Event) => {
    const input = event.target as HTMLInputElement;
    readFile(input.files?.[0]);
    // Otherwise picking the same file again doesn't fire change
    input.value = '';
};

const onDrop = (event: DragEvent) => {
    isDraggingOver.value = false;
    readFile(event.dataTransfer?.files[0]);
};

const close = () => emit('input', false);

const apply = () => {
    if (!selected.value) return;
    emit('apply', selected.value.pathData);
    close();
};

return { __sfc: true,MAX_FILE_MB, props, emit, source, fileError, selectedIndex, isDraggingOver, fileInput, candidates, selected, errorMsg, onSourceInput, readFile, openFilePicker, onFileSelected, onDrop, close, apply, CModal, CButton, CTextarea }
}

})